import { HotspotEntity, HotspotQueryParams, HotspotResponse } from '../types/hotspot';
import { getBackendUrl } from './configService';

export interface LifecycleHotspotParams {
  minLon: number;
  minLat: number;
  maxLon: number;
  maxLat: number;
  startDate: string;
  endDate: string;
  year?: number;
  region?: string;
  sensor?: string;
}

class HotspotService {
  private getBaseUrl(): string {
    return `${getBackendUrl()}/api/hotspots`;
  }

  async fetchData(params: HotspotQueryParams = {}): Promise<HotspotResponse> {
    const url = new URL(this.getBaseUrl());

    const stringKeys: (keyof HotspotQueryParams)[] = [
      'page', 'limit', 'sortBy', 'sortOrder',
      'startDate', 'endDate', 'confidence', 'source', 'ageClass',
    ];
    for (const key of stringKeys) {
      if (params[key] != null) url.searchParams.set(key, String(params[key]));
    }

    const numKeys: (keyof HotspotQueryParams)[] = [
      'minBrightness', 'maxBrightness', 'minFrp', 'maxFrp',
      'minLat', 'maxLat', 'minLon', 'maxLon',
    ];
    for (const key of numKeys) {
      if (params[key] != null) url.searchParams.set(key, String(params[key]));
    }

    const response = await fetch(url.toString(), { credentials: 'include' });
    if (!response.ok) {
      throw new Error(`Hotspot API error: ${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  async fetchLifecycleHotspots(params: LifecycleHotspotParams): Promise<HotspotEntity[]> {
    const url = new URL(`${this.getBaseUrl()}/lifecycle`);
    url.searchParams.set('minLon', String(params.minLon));
    url.searchParams.set('minLat', String(params.minLat));
    url.searchParams.set('maxLon', String(params.maxLon));
    url.searchParams.set('maxLat', String(params.maxLat));
    url.searchParams.set('startDate', params.startDate);
    url.searchParams.set('endDate', params.endDate);
    if (params.year) url.searchParams.set('year', String(params.year));
    if (params.region) url.searchParams.set('region', params.region);
    if (params.sensor) url.searchParams.set('sensor', params.sensor);

    const response = await fetch(url.toString(), { credentials: 'include' });
    if (!response.ok) {
      throw new Error(`Hotspot lifecycle API error: ${response.status} ${response.statusText}`);
    }
    const json = await response.json();
    return json.data as HotspotEntity[];
  }
}

export const hotspotService = new HotspotService();
export default hotspotService;
